import styled from '@emotion/styled';

import { ProductDetailContent } from '../types';
import {
  partnerBodyImageBuilder,
  partnerProductImageBuilder,
} from './utils/partnerProductDescriptionBuilder';

const Container = styled.div<{ isPC: boolean; }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: ${({ isPC }) => (isPC ? '1010px' : '710px')};
  padding: 0 10px;
  margin: 0 auto;
`;

const PCImage = styled.img`
  max-width: 1010px;
  object-fit: cover;
  margin-bottom: 40px;
`;

const MWImage = styled.img`
  max-width: 100%;
  object-fit: cover;
  margin-bottom: 40px;
`;

interface Props {
  partnerContent: ProductDetailContent[];
  isPC?: boolean;
}

export default function PartnerDescription({
  partnerContent,
  isPC = true,
}: Props) {
  const partnerBodyImage = partnerBodyImageBuilder(partnerContent, isPC);

  const partnerProductImage = partnerProductImageBuilder(partnerContent, isPC);

  const Image = isPC ? PCImage : MWImage;

  return (
    <Container isPC={isPC}>
      {partnerBodyImage && (
        <Image
          src={partnerBodyImage}
          alt="컬리 파트너스 바디 이미지"
        />
      )}
      {partnerProductImage && (
        <Image
          src={partnerProductImage}
          alt="컬리 파트너스 상품 이미지"
        />
      )}
    </Container>
  );
}

